import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FilterContainer from './FilterContainer';
import ChangePasswordModal from './ChangePasswordModal';
import TwoFactorAuthModal from './TwoFactorAuthModal';

const MoreSettings = () => {
  const navigate = useNavigate();
  const { tab } = useParams();
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [show2FAModal, setShow2FAModal] = useState(false);

  const handleSettingClick = (path) => {
    if (path === 'change-password-modal') {
      setShowPasswordModal(true);
    } else if (path === '2fa-modal') {
      setShow2FAModal(true);
    } else {
      navigate(path);
    }
  };

  const settingsItems = [
    {
      id: 'skills',
      label: 'Skills',
      icon: '/Icons/heart-icon.svg',
      path: '/dashboard/more-settings/skills',
      bgColor: 'bg-blue-50'
    },
    {
      id: 'project-filters',
      label: 'Project Filters',
      icon: '/Icons/project-filter-icon.svg',
      path: '/dashboard/more-settings/project-filters',
      bgColor: 'bg-blue-50'
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: '/Icons/setting-bell-icon.svg',
      path: '/dashboard/more-settings/notifications',
      bgColor: 'bg-blue-50'
    },
    {
      id: '2fa',
      label: '2-Factor Authentication',
      icon: '/Icons/key-icon.svg',
      path: '2fa-modal', 
      bgColor: 'bg-blue-50'
    },
    {
      id: 'change-password',
      label: 'Change Password',
      icon: '/Icons/lock-icon.svg',
      path: 'change-password-modal',
      bgColor: 'bg-blue-50'
    },
  ];

  const bidSettingsItems = [
    {
      id: 'bid-price',
      label: 'Bid Price',
      icon: '/Icons/dollar-icon.svg',
      path: '/dashboard/more-settings/bid-price',
      bgColor: 'bg-blue-50'
    },
  ];

  const autoBidSettingsItems = [
    {
      id: 'auto_bid',
      label: 'Auto Bid Schedule',
      icon: '/Icons/dollar-icon.svg',
      path: '/dashboard/more-settings/auto_bid',
      bgColor: 'bg-blue-50'
    },
  ];

  const SettingCard = ({ item }) => (
    <button
      onClick={() => handleSettingClick(item.path)}
      className="w-full flex items-center justify-between p-2 bg-white border-[1.5px] border-gray-200 rounded-xl hover:border-primary-blue hover:shadow-md transition-all group"
    >
      <div className="flex items-center gap-4">
        <div className={`w-14 h-14 ${item.bgColor} rounded-xl flex items-center justify-center`}>
          <img src={item.icon} alt={item.label} className="w-14 h-14" />
        </div>
        <span className="text-base font-medium text-gray-900">{item.label}</span>
      </div>
      <img 
        src="/Icons/next-icon.svg" 
        alt="Go" 
        className="w-8 h-8 opacity-60 group-hover:opacity-100 transition-opacity"
      />
    </button>
  );

  // If there's a tab parameter, show the filter content using the wider container
  if (tab) {
    return (
      <div className="max-w-6xl xl:max-w-7xl 2xl:max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <FilterContainer activeTab={tab} />
      </div>
    );
  } 

  // Otherwise, show the settings cards
  return (
       <div className="max-w-6xl xl:max-w-7xl 2xl:max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <header className="mb-6">
        <div className="flex items-center gap-4 mb-2">
          <button 
            onClick={() => navigate('/dashboard')}
            className="flex items-center justify-center"
          >
            <img src="/Icons/arrow-back.svg" alt="Back" className="w-8 h-8" />
          </button>
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        </div>
      </header>

      {/* Settings Section */}
      <div className="space-y-4 mb-10">
        {settingsItems.map((item) => (
          <SettingCard key={item.id} item={item} />
        ))}
      </div>

      {/* Bid Settings Section */}
      <div className="mt-10">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Bid Settings</h2>
        <div className="space-y-4">
          {bidSettingsItems.map((item) => (
            <SettingCard key={item.id} item={item} />
          ))}
        </div>
      </div>

      {/* Auto Bid Settings Section */}
      <div className="mt-10">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Auto Bid Settings</h2>
        <div className="space-y-4">
          {autoBidSettingsItems.map((item) => (
            <SettingCard key={item.id} item={item} />
          ))}
        </div>
      </div>


      {/* Change Password Modal */}
      <ChangePasswordModal 
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
      />

      {/* 2-Factor Authentication Modal */}
      <TwoFactorAuthModal 
        isOpen={show2FAModal}
        onClose={() => setShow2FAModal(false)}
      />
    </div>
  );
};

export default MoreSettings;
